"use strict";

// TODO - add HS code here. This file exists to keep other app bundle files from
// accessing the HS global object. (CC)

module.exports = global.HelloSign || {};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/hellosign.js
 ** module id = 626
 ** module chunks = 0
 **/